import { parseData, post } from './common';
const getFilesInPath = (payload) => {
    return post('/InternalAPI/SFTPAPI.asmx/GetFilesInPath', payload).then(parseData);
};
const updateDirectoryStatus = (payload) => {
    return post('/InternalAPI/SFTPAPI.asmx/UpdateDirectoryStatus', payload).then(parseData);
};
const updateFile = (payload) => {
    return post('/InternalAPI/SFTPAPI.asmx/UpdateFile', payload).then(parseData);
};
const addPath = (payload) => {
    return post('/Services/SFTPService.asmx/AddPath', {
        Payload: payload
    }).then(parseData);
};
const uploadFile = (payload) => {
    return post('/InternalAPI/SFTPAPI.asmx/CreateFile', payload).then(parseData);
};
const downloadFile = (payload) => {
    return post('/InternalAPI/SFTPAPI.asmx/GetFile', payload).then(parseData);
};
export { getFilesInPath, addPath, uploadFile, downloadFile, updateFile, updateDirectoryStatus };
